export const Easings = {
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeOutCubic: [0.33, 1, 0.68, 1],
  one: [0.6, -0.05, 0.01, 0.9],
} as const;
